// extracted by mini-css-extract-plugin
module.exports =  {"carouselContainer":"carouselContainer_UBuNJtCM","sliderIndication":"sliderIndication_irbtt9Q1"};